var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"text-h5"},[_vm._v("Política de Privacidade")]),_c('v-spacer')],1),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_vm._v(" Aguarde, em breve ... ")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }